import React from 'react';
import PropTypes from 'prop-types';

import currency from 'currency.js';

const USD = (value) => currency(value);
const EUR = (value) => currency(value, {
  symbol: '€', decimal: ',', separator: '.', pattern: '# !',
});

const CLCurrency = ({ value, currency }) => {
  const localeCurrency = 'USD';
  const abbr = currency || localeCurrency;

  return (
    <>
      {abbr === 'USD' && USD(value).format()}
      {abbr === 'EUR' && EUR(value).format()}
    </>
  );
};

CLCurrency.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currency: PropTypes.oneOf(['', 'USD', 'EUR']),
};

CLCurrency.defaultProps = {
  value: 0,
  currency: '',
};

export default CLCurrency;
